import { isSome } from '@nike/rcf-fp';

/* eslint-disable import/prefer-default-export */
export const getStoreDisplayName = (store) => (isSome(store)
    ? `${store.storeNumber} - ${store.name}`
    : '');
